import {
  FAQS,
  AnalyticsHeader,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const LogoImage = "https://ss-leagues.s3.amazonaws.com/NBA/atlanta-hawks.png";
const OrderSummaryBackgroundImage =
  "https://ss-leagues.s3.amazonaws.com/NBA%202024-25/Hawks%20Draft%20Deal/2425_HWK_MB_pURLToolkit_Backgrounds_1920x1080_2.jpg";

export const atlantahawks_pass: TTeamConfig = {
  TEAM_SCHEMA: "atlantahawks_pass",
  TEAM_FULL_NAME: "Atlanta Hawks",
  BROWSER_TITLE: "Atlanta Hawks 3-Game Draft Pack",
  CLIENT_ID: "a8b399c349c9.seasonshare.hawks-atl_spirit.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#000000",
    COLORS_SECONDARY: "#C8102E",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },
    ANALYTICS_HEADER: AnalyticsHeader,
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Purchase Now",
      SHOW_FAQ_BUTTON: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_COLOR: "#C8102E",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
      ADDITIONAL_DETAILS: {
        ADDITIONAL_DETAILS_LABEL: "Bonus Game",
      },
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: LogoImage,
    ORDER_SUMMERY_BACKGROUND_URL: OrderSummaryBackgroundImage,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PRE_PURCHASE_FAQS: FAQS,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
